var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    class: [_vm.$style.overlay, _vm.$style[_vm.ticketStatusClass]]
  }, [_c('div', {
    class: _vm.$style.container
  }, [_vm.isNewTicket ? [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: [_vm.$style.icon, _vm.$style.new]
  }, [_c('base-icon', {
    attrs: {
      "name": "basic_check-mark",
      "size": 64
    }
  })], 1), _c('div', {
    class: _vm.$style.text,
    domProps: {
      "textContent": _vm._s(_vm.$t('ticket.code.status.new'))
    }
  }), _c('div', {
    class: _vm.$style.details
  }, [_c('div', {
    class: _vm.$style.detail
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('ticket.code.number'))
    }
  }), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.ticketCode)
    }
  })]), _c('div', {
    class: _vm.$style.detail
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('ticket.code.created.at'))
    }
  }), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.ticketCreatedAt)
    }
  })]), _vm.displayDescription ? _c('div', {
    class: _vm.$style.detail
  }, [_vm._v(" " + _vm._s(_vm.displayDescription) + " ")]) : _vm._e()])])] : _vm.isShownTicket ? [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: [_vm.$style.icon, _vm.$style.shown]
  }, [_c('base-icon', {
    attrs: {
      "name": "basic_check-marks",
      "size": 64
    }
  })], 1), _c('div', {
    class: _vm.$style.text,
    domProps: {
      "textContent": _vm._s(_vm.$t('ticket.code.status.shown'))
    }
  }), _c('div', {
    class: _vm.$style.detail
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('ticket.code.last.shown.at'))
    }
  }), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.ticketLastShownAt)
    }
  })]), _c('div', {
    class: _vm.$style.details
  }, [_c('div', {
    class: _vm.$style.detail
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('ticket.code.number'))
    }
  }), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.ticketCode)
    }
  })]), _c('div', {
    class: _vm.$style.detail
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('ticket.code.created.at'))
    }
  }), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.ticketCreatedAt)
    }
  })]), _vm.displayDescription ? _c('div', {
    class: _vm.$style.detail
  }, [_vm._v(" " + _vm._s(_vm.displayDescription) + " ")]) : _vm._e()])])] : [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: [_vm.$style.icon, _vm.$style.unknown]
  }, [_c('base-icon', {
    attrs: {
      "name": "file_clipboard-delete",
      "size": 64
    }
  })], 1), _c('div', {
    class: _vm.$style.text,
    domProps: {
      "textContent": _vm._s(_vm.$t('ticket.code.status.unknown'))
    }
  })])]], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }